import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Grid, Avatar } from "@mui/material";
import { RocksContainer } from "../HeroComponent";
import Rock9 from "../../assets/Rocks/rock9.svg";
import Rock4 from "../../assets/Rocks/rock4.svg";
import Rock1 from "../../assets/Rocks/rock1.svg";
import Rock6 from "../../assets/Rocks/rock6.svg";

const HowItWorksWeb = (props) => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      mt={-15}
      mb={5}
      sx={{ display: props.display }}
    >
      <Grid item>
        <Typography variant="h2" mb={3}>
          {t("howItWorksComponent.title")}
        </Typography>
      </Grid>
      <Grid
        container
        item
        justifyContent="center"
        alignItems="flex-start"
        spacing={8}
        xs={12}
      >
        {props.steps.map((step) => (
          <Grid
            container
            item
            xs={2.7}
            justifyContent="center"
            key={`step:${step.number}`}
          >
            <Grid item>
              <img
                src={step.image}
                width="100%"
                height="auto"
                alt={step.mumber}
              ></img>
            </Grid>
            <Grid container item alignItems="center">
              <Grid item mr={2}>
                <Avatar>
                  <Typography variant="h4">{step.number}</Typography>
                </Avatar>
              </Grid>
              <Grid item md={4}>
                <Typography variant="h3" mt={0.2}>
                  {step.title}
                </Typography>
              </Grid>
            </Grid>
            <Grid item md={12}>
              <Typography variant="h4" mt={2}>
                {step.content}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <RocksContainer>
        <img
          src={Rock9}
          width="5%"
          height="auto"
          alt="rock9howitworks"
          style={{
            position: "absolute",
            left: "18%",
            top: -920,
            zIndex: 9999999,
          }}
        />
        <img
          src={Rock4}
          width="auto"
          height="auto"
          alt="rock4howitworks"
          style={{
            position: "absolute",
            right: "25%",
            top: -720,
            zIndex: 9999999,
          }}
        />
        <img
          src={Rock1}
          width="auto"
          height="auto"
          alt="rock1howitworks"
          style={{
            position: "absolute",
            right: "28%",
            top: 35,
            zIndex: 9999999,
          }}
        />
        <img
          src={Rock6}
          width="auto"
          height="auto"
          alt="rock6howitworks"
          style={{
            position: "absolute",
            left: "19%",
            top: 250,
            zIndex: 9999999,
          }}
        />
      </RocksContainer>
    </Grid>
  );
};
export default HowItWorksWeb;
